export default __webpack_public_path__ + "static/media/bg3.bc42ee34.jpg";